import React from "react";

const StreamingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#9F00FF]/10 to-[#FB19E2]/10 flex flex-col items-center justify-center p-6">
      <h1 className="text-3xl sm:text-4xl font-bold text-purple-700 mb-4">
        📺 Live Streaming Zone
      </h1>
      <p className="text-gray-600 text-center max-w-md mb-8">
        Watch your favorite teams perform live and enjoy the ultimate dance showdown!
      </p>

      <button
        className="px-6 py-3 rounded-xl bg-gradient-to-r from-[#9F00FF] to-[#FB19E2] text-white font-medium hover:opacity-90 transition shadow-lg"
        onClick={() => alert("Streaming feature coming soon!")}
      >
        Watch Now
      </button>
    </div>
  );
};

export default StreamingPage;
